'use strict';

var HEADER_OFFSET_SELECTORS = ['#lvz-top-banner', '#lvz-header-template', '#lvz-header-info-container'];

/**
 * Lowest visible bottom edge among sticky header layers.
 * @returns {number}
 */
function getHeaderOffset() {
	return HEADER_OFFSET_SELECTORS.reduce(function (maxBottom, selector) {
		var element = document.querySelector(selector);

		if (!element) {
			return maxBottom;
		}

		var rect = element.getBoundingClientRect();

		if (rect.height < 1 || rect.bottom <= 0) {
			return maxBottom;
		}

		return Math.max(maxBottom, rect.bottom);
	}, 0);
}

/**
 * Scrolls the page to the first invalid field inside a form.
 * @param {Element|jQuery} form - Form element or jQuery collection
 * @returns {void}
 */
function scrollToFirstError(form) {
	var $form = $(form);
	var $firstError = $form.find('.form-control.is-invalid').first();

	if (!$firstError.length) {
		$firstError = $form.find('.invalid-feedback').filter(function () {
			return $.trim($(this).text()).length > 0;
		}).first();
	}

	if (!$firstError.length) {
		return;
	}

	var $target = $firstError.closest('.form-group');
	if (!$target.length) {
		$target = $firstError;
	}

	var targetEl = $target.get(0);
	if (!targetEl) {
		return;
	}

	var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	var destination = targetEl.getBoundingClientRect().top + scrollTop - getHeaderOffset() - 16;

	window.scrollTo({
		top: Math.max(0, destination),
		behavior: 'smooth'
	});
}

module.exports = scrollToFirstError;
